import Vue from 'vue';

const getters = {
  userChannel: () => ({
    name: (() => {
      const type = (Vue.Custom.getCookies() || {}).acct_type;
      if (type === 'qc') {
        return 'QQ';
      } if (type === 'wx') {
        return '微信';
      }
      return '账号';
    })(),
    value: (Vue.Custom.getCookies() || {}).acct_type === 'qc' ? 'qq' : (Vue.Custom.getCookies() || {}).acct_type,
  }),
  userPlatform: () => ({
    name: (() => {
      const { device } = Vue.Custom.getCookies() || {};
      if (device === 'and') {
        return '安卓';
      } if (device === 'ios') {
        return 'ios';
      }
      return device;
    })(),
    value: (Vue.Custom.getCookies() || {}).device,
  }),
};

export default getters;
